'use client';
import { useEffect } from 'react';
import { useLinkStatus } from 'next/link';
import { GlobalStyles } from '@unity/cloud-ui';
import nProgress from 'nprogress';

nProgress.configure({ showSpinner: false });

export function NavigationProgressStyles() {
  return (
    <GlobalStyles
      styles={(theme) => ({
        // styles customized from https://github.com/rstacruz/nprogress/blob/master/nprogress.css
        '#nprogress': {
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          zIndex: theme.zIndex.appBar + 1,
          '& .bar': {
            background: theme.vars.palette.primary.main,
            position: 'fixed',
            top: 0,
            left: 0,

            width: '100%',
            height: '2px',
          },
          '& .peg': {
            display: 'block',
            position: 'absolute',
            right: '0px',
            width: '100px',
            height: '100%',
            boxShadow: `0 0 10px ${theme.vars.palette.primary.main}, 0 0 5px ${theme.vars.palette.primary.main}`,
            opacity: 1,
            transform: 'rotate(3deg) translate(0px, -4px)',
          },
        },
      })}
    />
  );
}

export function NavigationProgress() {
  const { pending } = useLinkStatus();

  useEffect(() => {
    if (pending) {
      nProgress.start();
    } else {
      nProgress.done();
    }
  }, [pending]);

  return null;
}
